import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

export class configItem {
    createdAt:firebase.firestore.Timestamp;
    updatedAt:firebase.firestore.Timestamp;
    version:number;
    sentences:[];
}